<template lang="pug">
  .ordit-dropdown.position-relative(v-click-outside="close")
    .btn.btn-secondary.d-inline-flex(ref="button" v-if="$slots.default" :class="allButtonClasses" @click="toggle")
      span.text-ellipsis.d-flex.w-100
        slot
      icon(:class="{up: isOpen}" :icon="buttonIcon" size="sm")
    .ordit-dropdown-menu.d-flex.flex-column.position-absolute.pointer-event(:class="{open: isOpen ,right: right, up}" :style="dropDownStyle")
      .ordit-dropdown-header.d-flex.align-items-center.justify-content-between.px-5(v-if="smDevice").border-bottom
        template(v-if="$slots.header")
          slot(name="header")
        template(v-else)
          h2.mb-0
            slot
          .btn.btn-secondary.btn-icon.btn-sm.rounded-circle(@click="close")
            icon(icon="fa-solid fa-times")
      .ordit-dropdown-content.flex-grow-1.overflow-auto.p-3
        slot(name="content")
</template>
<script>
import ClickOutside from 'vue-click-outside'
import { mapGetters } from 'vuex'

export default {
    name: 'Dropdown',
    directives: {
        ClickOutside,
    },
    components: {},
    props: {
        block: Boolean,
        disabled: Boolean,
        noButton: Boolean,
        xs: Boolean,
        right: Boolean,
        buttonClasses: {
            type: Array,
            default: () => [],
        },
        closeIcon: {
            type: String,
            default: 'fa-solid fa-times',
        },
        buttonIcon: {
            type: [String, Array],
            default: 'fa-solid fa-chevron-down',
        },
    },
    data() {
        return {
            isOpen: false,
            up: false,
        }
    },
    computed: {
        ...mapGetters(['smDevice']),
        allButtonClasses() {
            const items = [...this.buttonClasses]
            if (this.xs) {
                items.push('btn-xs')
            }
            if (this.isOpen) {
                items.push('active')
            }
            return items
        },
        dropDownStyle() {
            if (!this.smDevice) {
                return null
            }
            return `height:${window.innerHeight}px`
        },
    },
    watch: {
        $route() {
            this.close()
        },
    },
    mounted() {},
    beforeDestroy() {},
    methods: {
        calculateDirection() {
            if (!this.$refs.button) {
                return false
            }

            if (this.smDevice) {
                return false
            }

            const rect = this.$refs.button.getBoundingClientRect()
            const viewportHeight = window.innerHeight

            const spaceBelow = viewportHeight - rect.bottom
            const spaceAbove = rect.top

            this.up = spaceAbove > spaceBelow
        },
        toggle() {
            if (this.isOpen) {
                this.close()
            } else {
                this.open()
            }
        },
        open() {
            this.calculateDirection()
            this.isOpen = true
            if (this.smDevice) {
                this.$store.dispatch('blockScroll', true)
            }
            this.$emit('open')
        },
        close() {
            if (this.isOpen && this.smDevice) {
                this.$store.dispatch('blockScroll', false)
            }
            this.isOpen = false
            this.$emit('close')
        },
    },
}
</script>
